export enum VisitSidePanelTabs {
   MEDICAL_DATA = 'MEDICAL_DATA',
   VISITS_HISTORY = 'VISITS_HISTORY',
   NOTES = 'NOTES',
   CONSENTS = 'CONSENTS',
   AI_ASSISTANT = 'AI_ASSISTANT',
}
export type VisitSidePanelTabIdUnion = keyof typeof VisitSidePanelTabs;
